<template>
  <!-- eslint-disable max-len -->
  <div class="bpc-table-contacts">
    <div class="dropdown-menu-header">
      <div class="dropdown-menu-header-inner bg-info">
          <div class="menu-header-image opacity-2 dd-header-bg-6"></div>
          <div class="menu-header-content text-left">
              <div class="widget-content p-0">
                  <div class="widget-content-wrapper">
                      <div class="widget-content-left mr-3">
                          <img width="42" class="rounded-circle" :src="item.img_url" alt="">
                      </div>
                      <div class="widget-content-left">
                          <div class="widget-heading">{{item.name.last}} {{item.name.first}}</div>
                          <!-- <div class="widget-subheading opacity-8">{{value.relation}}</div> -->
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </div>
    <div v-if="item.contact_details.phone || item.contact_details.phone2 || item.contact_details.email || item.contact_details.email2" class="scroll-area-xs" style="height: auto">
        <VuePerfectScrollbar class="scrollbar-container">
          <ul class="contact-details">
            <li>
              <a v-if="item.contact_details.phone" href="javascript:void(0);" class="btn btn-link">
                <i class="pe-7s-phone mr-2"></i>
                {{item.contact_details.phone}}</a>
            </li>
            <li>
              <a v-if="item.contact_details.phone2" href="javascript:void(0);" class="btn btn-link">
                <i class="pe-7s-phone mr-2"></i>
                {{item.contact_details.phone2}}</a>
            </li>
            <li>
              <a v-if="item.contact_details.email" href="javascript:void(0);" class="btn btn-link">
                <!-- <i class="pe-7s-mail mr-2"></i> -->
                {{item.contact_details.email}}</a>
            </li>
            <li>
              <a v-if="item.contact_details.email2" href="javascript:void(0);" class="btn btn-link">
                <!-- <i class="pe-7s-mail mr-2"></i> -->
                {{item.contact_details.email2}}</a>
            </li>
          </ul>
        </VuePerfectScrollbar>
    </div>
    <ul class="nav flex-column">
        <li class="nav-item-divider mb-0 nav-item"></li>
    </ul>
    <div class="grid-menu grid-menu-2col overflow-hidden">
        <div class="no-gutters row">
            <div class="col-sm-6">
                <button class="_btn-icon-vertical _btn-transition _btn-transition-alt _pt-2 _pb-2 btn _btn-outline-warning"><i class="pe-7s-chat _icon-gradient _bg-amy-crisp _btn-icon-wrapper mr-2"> </i>Message</button>
            </div>
            <div class="col-sm-6">
                <button class="_btn-icon-vertical _btn-transition _btn-transition-alt _pt-2 _pb-2 btn _btn-outline-danger"><i class="pe-7s-ticket _icon-gradient _bg-love-kiss _btn-icon-wrapper mr-2"> </i><b>View</b>
                </button>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faStar,
  faPlus,
  faTrash,
  faPlay,
  faForward,
  faRocket,
  faQuestion,
  faEdit,
  faEllipsisH,
} from '@fortawesome/free-solid-svg-icons';


import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import avatar1 from '@mockups/assets/avatars/1.jpg';
import avatar2 from '../assets/avatars/2.jpg';
import avatar3 from '../assets/avatars/3.jpg';
import avatar4 from '../assets/avatars/4.jpg';
import avatar5 from '../assets/avatars/5.jpg';
import avatar6 from '../assets/avatars/6.jpg';
import avatar7 from '../assets/avatars/7.jpg';
import avatar8 from '../assets/avatars/8.jpg';
import avatar9 from '../assets/avatars/9.jpg';
import avatar10 from '../assets/avatars/10.jpg'; 

library.add(
  faStar,
  faPlus,
  faTrash,
  faPlay,
  faForward,
  faRocket,
  faQuestion,
  faEdit,
  faEllipsisH,
);

export default {
  components: {
    // 'font-awesome-icon': FontAwesomeIcon,
  },
  props: {
    item: Object,
  },
  data: () => ({
  }),
};
</script>

<style scoped>
ul.contact-details {
  list-style: none;
  margin: 0;
  padding: 0;
}
ul.contact-details li {
  display: inline-block;
  width: 50%;
}
</style>
